define([
    "jwplayer",
    "underscore/underscore",
    "templates/cuehelper_template.handlebars",
    "templates/cuehelper_cue-dots.handlebars",
    "./cuehelper.less"
],function(jwplayer,_,_template,_cuedots,style){

	module.exports = function(pluginName, buttonImg){
		return function (player, config, cuehelper){

    var overlayout, 
        $container,
        showOrHide = -1 ,
        cueDisplayable = -1,
        

        infos = {},

        introductions = {},
        titles = {},

        cuePointsArr = {},
        currentIndex = 0,
        currentCue,
        currentCuePointsArr = [],

        duration,
        sliderW,
        panelW,
        panelH,
        needRedraw,

        lang = {
            noResultText:"暂无数据",
            clickForReloopText: "点击循环播放"
        },
        options={
            dockname:'图标名',
            container_id:0,
            title:'标题',
            introduction: '简介',
            //dimensions:'100x100',
            file: '',
            repeatable:true,
            area:"block", // "block" | dot?
            color:"666",
            layout:'vertical',
            lang: lang
        };
      
     

        options = $.extend( options, config);
        options.container_id = $(cuehelper).attr("id");
        var o = options, 
            p = this,
            pannelID = "#"+ player.id+" #cp_container"+ o.container_id +" .cuepoints-panel", 
            sliderID = "#"+ player.id+" #cue_dots_"+o.container_id,
            error = false,  

            hidePanel = function (){
                showOrHide *= -1;
                $container.fadeOut();
            },

            toggleDisplay = function (){

                if($(pannelID).length){
                    if($(pannelID).width()){
                        
                        if(needRedraw){
                    
                            var parentW = $(pannelID).parent().width(),
                                parentH = $(pannelID).parent().height(),
                            w =  parseInt( panelW / parentW),
                            scale = panelH / parentH,
                            left = (panelW - scale * parentW)/2,
                            a = {
                                width:panelW,
                                height :panelH
                            };

                            scale = scale > 1 ? scale: 1;
                         


                            $container.animate(a);
                            a.height *= 1;
                            $container.find(".cp-layout").animate(a);
                            $(pannelID).animate({
                                zoom:scale*100+"%"}); 
                            // $(pannelID).find(".cue-pills").css("height",$(pannelID).find(".cue-pills").height()*scale);
                            needRedraw = false;
                            
                        }

                    }

                }


                if(cueDisplayable == 1){
                    $(pannelID+" #repeat_btn input[type=checkbox]").prop("checked", true);
                }else{
                    $(pannelID+" #repeat_btn input[type=checkbox]").prop("checked", false);
                }
            },
            redraw=function(width,height){
                if(width == undefined || width == 0 && height == 0){
                    // when jwplayer in a hidden 
                    return ;
                }
                if(panelW !== width){
                    needRedraw = true;
                    panelW = width;
                    panelH = height;

                    toggleDisplay();
                }

            },
            randomColor = function () {

                var bg_colour = Math.floor(Math.random() * 16777215).toString(16)
                bg_colour = "#" + ("000000" + bg_colour).slice(-6)
                return bg_colour;

            },
            positionDots = function(item, duration){

                var l = item.seekTime *100  / duration;
                // console.log($(sliderID+" #d_"+item.id));

                $(sliderID+" #d_"+item.id).css("left", l+"%");


                if(options.area == "block"){
                    var w = item.duration * sliderW / duration;
                    $(sliderID+" #d_"+item.id+" .cue-dot-area").css("width", w+"px");
                    //$(sliderID+" #d_"+item.id+" .cue-dot-area i").css("width", w+"px").css("border-bottom-color",randomColor);
                }
            },
            
            render = function(pointsArr, duration){


                // sortBy
                pointsArr = _.sortBy(pointsArr, "seekTime");

                // reduceRight add end duration
                _.reduceRight(pointsArr, function( end, item){
                   
                    item.end =  end;
                    item.duration = end - item.seekTime ;
                    //console.log(this);// windows
                  

                    return item.seekTime ;
                }, duration);
                       
                // render dots
                if($("#"+player.id + " .jw-slider-time .cue-dots-wrapper").length) 
                    $("#"+player.id + " .jw-slider-time .cue-dots-wrapper").remove();


                // console.log("cueDisplayable",cueDisplayable,o.color);

                if(cueDisplayable == 1){

                    cuedots = $(_cuedots({
                        cuePointsArr: pointsArr,
                        o:o,
                        bg:o.color
                    })).appendTo($("#"+player.id + " .jw-slider-time"));


                    _.each(pointsArr,function(item){
                         positionDots.call(this,item,duration);
                     },duration);
                     

                    cuedots.offset($(".jw-slider-time").offset());
                    cuedots.css("top",0);

                    $(document).on("mouseover", sliderID+" .cue-dot-area", function(e){
                        $(e.target).parent().find(".cue-dot-info").show();
                    });
                    $(document).on("mouseout",sliderID+" .cue-dot-area", function(e){
                        $(e.target).parent().find(".cue-dot-info").hide();
                    });
                }



                // render pills
                var temp =_template({
                        cuePointsArr: pointsArr,
                        o:options,
                        isEmpty: pointsArr.length ? true:false
                    });

                
                $container.append(temp);
                
            };


        function setup(evt){


            var playerWidthPX2 = player.getWidth() || $("#"+player.id).width();// when jwplayer in a hidden 
            var playerWidthPX = parseFloat(playerWidthPX2);
            var playerHeightPX2 = player.getHeight() || $("#"+player.id).height();
            var playerHeightPX = parseFloat(playerHeightPX2);

            $container = $("<div style='width:"+
                playerWidthPX+"px;height:"+
                playerHeightPX+"px;display:none;' class='cp-container' id='cp_container"+ o.container_id+"'></div>");
            
            overlayout = $("<div style='width:"+
                playerWidthPX + "px;height:"+
                playerHeightPX + "px;' class='cp-layout' id='cp_layout"+ o.container_id+"'></div>");

            // console.log("height:",playerHeightPX);
            overlayout.appendTo($container);
            // $container.appendTo($("#"+player.id));
            $container.appendTo(cuehelper);

            var that = this;
            

            var handleResponse = function (e){

                 $xml = $(e)
                 var firstGuid = "";
                 $xml.find("items").each(function(idx, items){
                        var guid = $(items).attr("guid");
                        cuePointsArr[guid] = [];
                        if(idx == 0 ) firstGuid = guid;


                        introductions[guid] = ($(items).find("description").text());
                        titles[guid] = ($(items).attr("title"));
                        var tempArr=[];

                        $(items).find("item").each(function(i,item){
                          
                            tempArr.push({
                                id: "cue"+i,
                                title: $(item).find("title").text(),
                                link: $(item).find("link").text(),
                                seekTime: parseInt($(item).find("seekTime").text())/1000
                            });

                        });
                        cuePointsArr[guid] = (tempArr);

                    })

                    currentCuePointsArr = cuePointsArr[firstGuid];

                    var thtml = _template({
                        cuePointsArr: currentCuePointsArr,
                        o:options,
                        isEmpty: currentCuePointsArr.length ? true:false
                    });

                    $container.append(thtml);



                    if(options.repeatable) {
                        cueDisplayable = 1
                        $(pannelID+" #repeat_btn input[type=checkbox]").prop("checked", true);
                    }else{
                            
                        cueDisplayable = -1;
                        $(pannelID+" #repeat_btn input[type=checkbox]").prop("checked", false);
                    }

            }
            $.ajax(o.file, {
                // dataType: 'text/xml',
                dataType: 'xml',
                success:function(e){
                    handleResponse.call(this,e);

                },
                error: function(e,reason){
                    
                    if(e.status == 200){
                        handleResponse.call(this,e.responseText);
                    }else{
                        error = true;
                    }
                }
            });

            redraw(playerWidthPX2, playerHeightPX2);


            // mouse event
            $(document).on("change", pannelID+" #repeat_btn input[type=checkbox]",function(e){
                
                cueDisplayable *= -1;

                // console.log(cueDisplayable,$(pannelID+" #repeat_btn input[type=checkbox]").prop("checked"));
           

                // if(cueDisplayable == 1){
                //     $(pannelID+" #repeat_btn input[type=checkbox]").prop("checked", true);
                // }else{
                //     $(pannelID+" #repeat_btn input[type=checkbox]").prop("checked", false);
                // }
            });

            $(document).on("click",pannelID+" .cp-layout",function(e){
                hidePanel();
            });
             $(document).on("click",pannelID+" .close-btn",function(e){
                hidePanel();
            });

            // cue event
            $(document).on("click", pannelID+" .cue", function(e){


                var targetCue = _.find(currentCuePointsArr, function(item){
                    return $(e.currentTarget).attr("id") == item.id; // cue1
                });
                
                //console.log(currentCue);
                hidePanel();
                player.seek(targetCue.seekTime);
                currentCue = targetCue;
            })



        }

        function start(evt){
                 
        }

        player.onPlaylistItem(function(item){
            // index == guid
            currentIndex = item.item.description;
            currentCuePointsArr = cuePointsArr[currentIndex];
        })


        player.onReady(setup);
        player.onPlay(start);
        player.onMeta(function(m){
            //meta 
            // console.log(m);
            sliderW = $(".jw-slider-time").width(); // error: width = 100
            // console.log(sliderW);// api
            if(m.duration || (m.metadata && m.metadata.duration) ){
                    // video:
                    // {duration: 25.770667, height: 900, width: 1200, type: "meta"}
                    // when vod metadata would not include duartion
                    // hsl:
                    // bandwidth: 238590
                    // currentLevel: "1 of 1 (769kbps, 1080px)"
                    // droppedFrames: 0
                    // width: 700
               

                    // rtmp:
                    // Server: "C++ RTMP Media Server (www.rtmpd.com)"
                    // audioFramesCount: 2136
                    // audiochannels: 2
                    // audiocodecid: "mp4a"
                    // audiosamplerate: 48000
                    // avclevel: 32
                    // avcprofile: 66
                    // bandwidth: 2214
                    // duration: 45.594
                    // endTimestamp: 45.594
                    // fileSize: 12753345
                    // framerate: 15.024005021356345
                    // height: 912
                    // provider: "rtmp"
                    // startTimestamp: 0
                    // stereo: true
                    // totalFramesCount: 2824
                    // type: "metadata"
                    // videoFramesCount: 686
                    // videocodecid: "avc1"
                    // width: 1200

                    // bandwidth: "6624"
                    // bufferfill: 6.7
                    // qualitylevel: 0
                    // screenwidth: 700
                    // transitioning: "false"



                if($(pannelID).length) 
                    $(pannelID).remove();


                if(m.metadata){
                    duration =  m.metadata.duration ;
                }else{
                    duration = m.duration ;
                }

                render(currentCuePointsArr, duration);
                if(introductions[currentIndex]) $(pannelID).find(".cuepoints-description").html(introductions[currentIndex]);
                if(titles[currentIndex]) $(pannelID).find(".cuepoints-title").html(titles[currentIndex]);
               
            }
        })

        

        // reloop
        player.onTime(function(t){
            //{type: "time", position: 20.75, duration: 25.771}

            if(cueDisplayable == 1 && currentCue !== undefined){
                // console.log(cueDisplayable,currentCue.duration);
               // t.position > current
              // console.log(currentCue)
                if(t.position >= (currentCue.seekTime + currentCue.duration)){
                 //   console.log(t);
                    player.seek(currentCue.seekTime);
                }
            }
        });


        player.onIdle(function(idle){
            // console.log(idle, "idle");
        })

        player.onControls(function(c){
            // console.log(c, "onControls");
        })
        this.resize = function(width, height){

            redraw(width,height);
            

            player.addButton(buttonImg, 
            o.dockname, 
            function() {
                showOrHide *= -1;

                if(showOrHide == 1){
                    $container.fadeIn(toggleDisplay);
                }else{
                    $container.fadeOut();
                }
            }, 
            pluginName);
        }
        
    };
}


});


//////////////////
// WEBPACK FOOTER
// ./src/webpack/cuehelper-core.js
// module id = 26
// module chunks = 2 3